module.exports = {
      id: "politics-usage",
      viewBox: "0 0 93.75 88.955",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#politics",
      toString: function () {
        return this.url;
      }
    }